var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chart-container" }, [
    _c(
      "figure",
      {
        attrs: { role: "group", "aria-labelledby": "chart-title-" + _vm._uid },
      },
      [
        _c(
          "figcaption",
          { staticClass: "sr-only", attrs: { id: "chart-title-" + _vm._uid } },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("monitoring.chart_status_distribution_title")) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { "aria-hidden": true } },
          [
            _c("pie-chart", {
              ref: "pieChartAll",
              attrs: {
                "chart-data": _vm.pieChartDataAll,
                options: _vm.chartOptionsAll,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass: "sr-only",
            attrs: {
              "aria-label": _vm.$t("monitoring.chart_data_table_label"),
            },
          },
          [
            _c("caption", [
              _vm._v(
                _vm._s(_vm.$t("monitoring.chart_status_distribution_detail"))
              ),
            ]),
            _vm._v(" "),
            _c("thead", [
              _c("tr", [
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(_vm._s(_vm.$t("monitoring.status_label"))),
                ]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(_vm._s(_vm.$t("monitoring.count_label"))),
                ]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(_vm._s(_vm.$t("monitoring.percentage_label"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("tbody", [
              _vm.pieChartDataAll
                ? _c("tr", [
                    _c("th", { attrs: { scope: "row" } }, [
                      _vm._v(_vm._s(_vm.$t("monitoring.status_all_test_ok"))),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.pieChartDataAll.datasets[0].data[0])),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.getPercentage(
                            _vm.pieChartDataAll.datasets[0].data[0]
                          )
                        ) + "%"
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pieChartDataAll
                ? _c("tr", [
                    _c("th", { attrs: { scope: "row" } }, [
                      _vm._v(_vm._s(_vm.$t("monitoring.status_no_enrollment"))),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.pieChartDataAll.datasets[0].data[1])),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.getPercentage(
                            _vm.pieChartDataAll.datasets[0].data[1]
                          )
                        ) + "%"
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pieChartDataAll
                ? _c("tr", [
                    _c("th", { attrs: { scope: "row" } }, [
                      _vm._v(_vm._s(_vm.$t("monitoring.status_planned"))),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.pieChartDataAll.datasets[0].data[2])),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.getPercentage(
                            _vm.pieChartDataAll.datasets[0].data[2]
                          )
                        ) + "%"
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pieChartDataAll
                ? _c("tr", [
                    _c("th", { attrs: { scope: "row" } }, [
                      _vm._v(_vm._s(_vm.$t("monitoring.status_in_testing"))),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.pieChartDataAll.datasets[0].data[3])),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.getPercentage(
                            _vm.pieChartDataAll.datasets[0].data[3]
                          )
                        ) + "%"
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }